"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function translate(translations, key, values = {}, opts = {}) {
  const fallback = opts.defaultMessage == null ? null : opts.defaultMessage;
  const translation = key in translations ? translations[key] : fallback;
  if (translation == null) {
    return key;
  }
  return Object.keys(values).reduce((acc, placeholder) => acc.replace(new RegExp(`__${placeholder}__`, "g"), String(values[placeholder])), translation);
}
var _default = translate;
exports.default = _default;